import cryptoJs from 'crypto-js'
import { cryptoKey } from '@/common/config'

export const getRem = function() {
  // 获取html根元素
  const html = document.querySelector('html')
  const baseFontSize = 100 // 设计稿100像素相当于1rem,750px--7.5rem---各种屏幕的100%的宽度
  const designWidth = 1920 // 设计稿的宽度
  var fontSize = (window.innerWidth / designWidth) * baseFontSize
  // 设置字体大小上限值
  fontSize = fontSize > 100 ? 100 : fontSize
  fontSize = fontSize < 50 ? 50 : fontSize
  html.style.fontSize = fontSize + 'px'
}

export const formatTime = time => {
  //   格式：yyyy-MM-dd hh:mm:ss
  const date = new Date(Number(time))
  const Y = date.getFullYear() + '-'
  const M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  const D =
    date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
  const h =
    date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
  const m =
    date.getMinutes() < 10
      ? '0' + date.getMinutes() + ':'
      : date.getMinutes() + ':'
  const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return Y + M + D + h + m + s
}

export const formatDate = time => {
  //   格式：yyyy-MM-dd
  const date = new Date(Number(time))
  const Y = date.getFullYear() + '-'
  const M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  const D =
    date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
  return Y + M + D
}

// 表格时间戳转日期
export const dateFormat = (row, column) => {
  const date = row[column.property]
  if (date === undefined || date === '') {
    return ''
  }
  return moment(date).format('YYYY-MM-DD HH:mm:ss')
}

// 获取url参数
export const getQueryString = name => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return ''
}

// crypto-js 加密
export const encryptDes = message => {
  const keyHex = cryptoJs.enc.Utf8.parse(cryptoKey)
  const option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
  const encrypted = cryptoJs.DES.encrypt(message, keyHex, option)
  return encrypted.ciphertext.toString() // 返回hex格式密文，如需返回base64格式：encrypted.toString()
}

// crypto-js 解密
export const decryptDes = message => {
  const keyHex = cryptoJs.enc.Utf8.parse(cryptoKey)
  const decrypted = cryptoJs.DES.decrypt(
    {
      ciphertext: cryptoJs.enc.Hex.parse(message)
    }, // 若message是base64格式，则无需转16进制hex，直接传入message即可
    keyHex,
    {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7
    }
  )
  return decrypted.toString(cryptoJs.enc.Utf8)
}

// 获取N天后的日期
export const getBeforeDate = (AddDayCount) => {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount);// 获取AddDayCount天后的日期
  var y = dd.getFullYear();
  var m = (dd.getMonth() + 1) < 10 ? "0" + (dd.getMonth() + 1) : (dd.getMonth() + 1);// 获取当前月份的日期，不足10补0
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();// 获取当前几号，不足10补0
  return y + "-" + m + "-" + d;
};